module.exports = __webpack_public_path__ + "static/media/biopic.a2722a66.jpg";